import { Action } from "redux"

import * as actions from "./actions"

export const initialState: Contracts.Contracts = {
    contracts: [],
    settings: undefined,
    editor: {
        visible: false,
        contract: undefined,
    },
    report: {
        visible: false,
        data: undefined,
    },
}

const handlers: {
    [action: string]: (
        state: Contracts.Contracts,
        props: Action,
    ) => Contracts.Contracts
} = {
    [actions.SET_INITIALIZED]: (state): Contracts.Contracts => ({
        ...state,
        initialized: true,
    }),

    [actions.REQUEST_CONTRACTS]: (state): Contracts.Contracts => ({
        ...state,
        validating: true,
    }),

    [actions.RECEIVE_CONTRACTS]: (
        state,
        { contracts }: actions.ReceiveContracts,
    ): Contracts.Contracts => ({ ...state, contracts, validating: false }),

    [actions.RECEIVE_CONTRACT]: (
        state,
        { contract }: actions.ReceiveContract,
    ): Contracts.Contracts => ({
        ...state,
        editor: { visible: true, contract },
    }),

    [actions.CLOSE_EDITOR]: (state): Contracts.Contracts => ({
        ...state,
        editor: { visible: false, contract: undefined },
    }),

    [actions.RECEIVE_GLOBAL_SETTINGS]: (
        state,
        { settings }: actions.GlobalSettings,
    ): Contracts.Contracts => ({ ...state, settings }),

    [actions.RECEIVE_REPORT]: (
        state,
        { data }: actions.ReceiveReport,
    ): Contracts.Contracts => ({ ...state, report: { visible: true, data } }),

    [actions.CLOSE_REPORT]: (state): Contracts.Contracts => ({
        ...state,
        report: { visible: false, data: undefined },
    }),
}

export default function reducer(
    state: Contracts.Contracts = initialState,
    action: Action,
): Contracts.Contracts {
    const handler: (
        state: Contracts.Contracts,
        action: Action,
    ) => Contracts.Contracts = handlers[action.type]
    return handler ? handler(state, action) : state
}
